// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"uyawV","customTable":"nKF2E"};